import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { HiArrowPathRoundedSquare } from 'react-icons/hi2';
export const ImageMagnifier = ({ imageSrc, showRotate }) => {
    const [backgroundPosition, setBackgroundPosition] = useState('0% 0%');
    const [hovered, setHovered] = useState(false);
    const [rotateDeg, setRotateDeg] = useState(0);
    const handleRotate = () => {
        const newDeg = rotateDeg >= 360 ? 0 : rotateDeg + 90;
        setRotateDeg(newDeg);
    };
    const handleToggleHover = () => {
        setHovered(!hovered);
    };
    const handleMouseMove = (e) => {
        const { left, top, width, height } = e.currentTarget.getBoundingClientRect();
        const x = ((e.pageX - left) / width) * 100;
        const y = ((e.pageY - top) / height) * 100;
        setBackgroundPosition(`${x}% ${y}%`);
    };
    if (!imageSrc)
        return null;
    return (_jsxs(_Fragment, { children: [_jsx("figure", { onMouseMove: handleMouseMove, style: {
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition,
                    backgroundImage: hovered ? `url(${imageSrc})` : 'none',
                    height: '100%',
                    margin: 0,
                }, onMouseEnter: handleToggleHover, onMouseLeave: handleToggleHover, children: _jsx("img", { src: imageSrc, alt: "", style: {
                        display: 'block',
                        width: '100%',
                        height: '100%',
                        objectFit: 'contain',
                        pointerEvents: 'none',
                        opacity: hovered ? 0 : 1,
                        transform: `rotate(${rotateDeg}deg)`,
                    } }) }), showRotate && (_jsx("div", { className: "absolute bottom-0 left-0 z-10 flex gap-x-1 divide-x rounded bg-white shadow-sm hover:shadow-md", children: _jsx("div", { className: "p-1", onClick: () => handleRotate(), children: _jsx(HiArrowPathRoundedSquare, { className: "text-primary-400 size-5 cursor-pointer" }) }) }))] }));
};
//# sourceMappingURL=image-magnifier.js.map